import {Client} from '@stomp/stompjs/esm6';
import {decodeBlob, encodeBlob, getValueOrDefault, isDefined, isEmpty, Locale, sep} from 'sdv-common';
import {debug, info, redirect, retryAfterMillis, serverAddress, wsApi} from '../shared/constants';

export class WebSocketService {

  readonly handlers = new Map<string, any[]>();
  readonly brokerURL: string = [serverAddress.replace(/^http/g, 'ws'), 'ws'].join(sep);
  readonly client: Client;

  constructor(callback = undefined) {
    this.client = new Client({
      reconnectDelay: retryAfterMillis,
      brokerURL: this.brokerURL,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000
    });

    let _this = this;
    this.client.onConnect = function (frame) {
      if (isDefined(callback)) {
        callback(frame);
      }

      _this.addSubscriber((response, headers) => {
        response.response = response.response || {};
        let responseData = response.response;
        let error = responseData.error;
        if (error) {
          if (error.id === 9) {
            redirect('/sign-out');
            return;
          }
          alert(error.code + ' - ' + error.message);
        }

        let handlers = getValueOrDefault(_this.handlers.get(response.id), []);
        if (isEmpty(handlers)) {
          info('Not found registered handlers for id:', response.id);
        }
        debug('Headers:', headers);
        handlers.forEach(h => h(response, headers));
      });
    };

    this.client.onStompError = function (frame) {
      info('Broker reported error: ' + frame.headers['message']);
      info('Additional details: ' + frame.body);
    };
  }

  registerHandler(command: string, callback) {
    let handlers = this.handlers.get(command);
    if (!handlers) {
      handlers = [];
    }
    handlers.push(callback);
    this.handlers.set(command, handlers);
  }

  addSubscriber(callback, destination: string = wsApi.broker) {
    this.client.subscribe(wsApi.buildSubscriber(destination), function (evt) {
      debug("STOMP Message subscriber:", evt);
      let response = decodeBlob(evt.binaryBody);
      response = JSON.parse(response);
      callback(response, evt.headers);
    });
  }

  send(request, token) {
    debug("STOMP Message publisher:", request);
    if (!this.client.connected) {
      let _this = this;
      setTimeout(() => {
        _this.send(request, token);
      }, 1000);
      return;
    }

    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': Locale.ENGLISH.name
    };
    if (token) {
      headers['Authorization'] = 'Bearer ' + token;
    }

    this.client.publish({
      destination: wsApi.buildPublisher([wsApi.internal.action]),
      binaryBody: encodeBlob(JSON.stringify(request)),
      headers
    });
  }

  start() {
    if (this.client) {
      this.client.activate();
    }
  }

  stop() {
    if (this.client) {
      this.client.deactivate();
    }
  }
}
